import { useEffect } from "react";
import { getAuditTrail, recordAuditEvent } from "../../lib/audit";
import { featureFlags } from "../../lib/featureFlags";
import { executeWebMcpTool, listWebMcpTools } from "./registry";

declare global {
  interface Window {
    __HOLOCRON_WEBMCP__?: {
      execute: typeof executeWebMcpTool;
      getAuditTrail: typeof getAuditTrail;
      tools: ReturnType<typeof listWebMcpTools>;
      version: string;
    };
  }
}

export function WebMcpBridge() {
  useEffect(() => {
    if (!featureFlags.webmcp) {
      return;
    }

    window.__HOLOCRON_WEBMCP__ = {
      execute: executeWebMcpTool,
      getAuditTrail,
      tools: listWebMcpTools(),
      version: "0.1.0"
    };

    recordAuditEvent({
      action: "webmcp.bridge_ready",
      actor: "webmcp",
      detail: "Feature-flagged WebMCP bridge registered on window.",
      outcome: "allowed",
      timestamp: new Date().toISOString()
    });

    return () => {
      delete window.__HOLOCRON_WEBMCP__;
    };
  }, []);

  return null;
}
